import React from "react";
import TwsStatus from "components/AdminDashboard/SystemControl/TwsStatus";
import AutomationRunningStatus from "./AutomationRunningStatus";
import { Divider } from "antd";
import { useSelector } from "react-redux";

const AutomationSettings = ({ ibcStatus, fetchIbAccountDetails }) => {
  const hasTelegramLinked = useSelector((state) => state.main.user.telegramId);

  return (
    hasTelegramLinked && (
      <div>
        <Divider orientation="left">Automation Settings</Divider>
        <div className="cards-wrapper">
          {ibcStatus && (
            <TwsStatus
              ibcStatus={ibcStatus}
              fetchIbAccountDetails={fetchIbAccountDetails}
            />
          )}
          <AutomationRunningStatus />
        </div>
      </div>
    )
  );
};

export default AutomationSettings;
